// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowAccount_wrapper__7V5Fd","title":"ShowAccount_title__x5uj7","see-more-btn":"ShowAccount_see-more-btn__xO80F"};